import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb } from 'react-icons/fi'
import Layout from '../components/Layout/Layout'

const About = () => {
  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Sobre nosotros
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-2">
              Sobre nosotros
            </h1>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <div>
              <h2 className="font-body font-light text-primary-text text-xl leading-relaxed mb-8">
                ¿Quiénes somos?
              </h2>
              <p className="font-body font-light text-primary-text text-lg leading-relaxed">
                Somos una empresa dedicada a la elaboración de artículos religiosos, con más de 21 años de experiencia en la fabricación de todo tipo de artículos, desde coronas, tiaras, cofres, cetros, rosarios, lazos, misterios y muchos más artículos.
              </p>
            </div>

            <div>
              <p className="font-body font-light text-primary-text text-lg leading-relaxed">
                Con reconocimiento nacional por nuestro trabajo exclusivo y patrocinios nacionales.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About